import PropTypes from 'prop-types';
import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { store } from '../..';
import { RESET_DOWNLOAD_STATE } from '../../store/actions/actionTypes';
import { getpagination } from '../../common/sysco-ui-components/services/commonServices';
import ReactTable from "react-table";
import { CSVLink } from 'react-csv';

// Helper to safely get array length (Sonar and build compatible)
const getLength = arr => Array.isArray(arr) ? arr.length : 0;

// Move Cell components outside the class to avoid defining them in render
const DocumentNameCell = ({ value }) => (
    <div className="showfullString">{value}</div>
);

const VendorInvoiceCell = ({ value }) => (
    <div className="showfullString">{value}</div>
);

export default class DownloadFailedModal extends Component {
        static propTypes = {
            isDownloadInProgress: PropTypes.bool.isRequired,
            failDownloadCount: PropTypes.number,
            failDownloadsList: PropTypes.arrayOf(PropTypes.object).isRequired
        };
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            csvFileHeaders: [
                { label: 'Document Name', key: 'fileName',width: '80%%' },
                { label: 'Invoice Number', key: 'InvoiceNumber',width: '80%%' }
            ]
        };
    }


    componentDidUpdate(prevProps) {
        if (
            !this.props.isDownloadInProgress &&
            prevProps.isDownloadInProgress !== this.props.isDownloadInProgress &&
            this.props.failDownloadCount > 0
        ) {
            this.setState({ show: true });
        }
    }

    handleClose = () => {
        this.setState({ show: false });
        store.dispatch({ type: RESET_DOWNLOAD_STATE })
    }


    render() {
        const { failDownloadsList } = this.props;

                const columns = [
                        {
                                Header: "Document Name",
                                accessor: "fileName",
                                Cell: ({ value }) => <DocumentNameCell value={value} />
                        },
                        {
                                Header: "Vendor Invoice #",
                                accessor: "InvoiceNumber",
                                Cell: ({ value }) => <VendorInvoiceCell value={value} />
                        },
                ];

        return (
            <Modal show={this.state.show} onHide={this.handleClose} >
                <Modal.Header closeButton>
                    <h4>Below files failed to download:</h4>
                </Modal.Header>
                <Modal.Body>
                    <ReactTable
                        className="-striped"
                        data={failDownloadsList.length !== 0 ? failDownloadsList : []}
                        columns={columns}
                        defaultPageSize={5}
                        pageSizeOptions={getpagination(getLength(failDownloadsList))}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <CSVLink data={failDownloadsList} headers={this.state.csvFileHeaders} 
                    filename={'Download-failed.csv'} className='btn btn-primary btn-sm' 
                    style={{ color: 'white', margin: '12px', padding:'15px' }} target='_blank' 
                    disabled={failDownloadsList.length === 0}
                    >
                    Export
                    </CSVLink>
                </Modal.Footer>
            </Modal>
        )
    }
}
